module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C295"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("EDITOR’S NOTE")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "C298"
  }, [_vm._v("The Aquamarine Issue is the fifth anniversary issue of FAIRY TALE REVIEW, and is appropriately its most oceanic, its most aesthetically diverse, issue to date. I often refer to my own method of identifying fairy tales as my sensing (through feeling and through close reading) what I call "), _c('em', [_vm._v("a fairy-tale feel")]), _vm._v(". The fairy-tale-ness of a work. I experienced fairy tales in every contribution you will find in The Aquamarine Issue. I felt a fairy-tale pulse.")])]), _c('p', {
    staticClass: "C298"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("I have been thinking, lately, in terms of French philosopher Gilles Deleuze’s discussion of "), _c('em', [_vm._v("affect")]), _vm._v(". Applying his concept of "), _c('em', [_vm._v("affect")]), _vm._v(" to new fairy-tale literature, one sees how these works may be identified atmospherically, scientifically, telepathically: in certain works, fairy tales are water and air. In "), _c('em', [_vm._v("Gilles Deleuze")]), _vm._v(", author Claire Colebrook illustrates this concept of affect as such: “A horror film presents horror; for beyond the fear of the characters of the viewer there is just a "), _c('em', [_vm._v("sense")]), _vm._v(" of the horror which the film draws upon. The film is not about horror, or a representation of horror; it is a sense or feeling of horror which we may or may not enter. Before the viewer or character is actually horrified we view within the affect or milieu of horror in general.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Editor_s_Note#id_3",
      "id": "id_2"
    }
  }, [_vm._v("1")]), _vm._v(" This Deleuzian notion of affect helps explain the range of writing that you’ll find here, as in every issue of FAIRY TALE REVIEW. The works are not about fairy tales, or a representation of fairy tales; it is a sense or feeling of fairy tales which we may or may not enter. In true fairy-tale fashion, I borrow her words: “Before the reader or character is actually "), _c('em', [_vm._v("enchanted")]), _vm._v(", we view within the affect or milieu of "), _c('em', [_vm._v("fairy tales")]), _vm._v(" in general.”")]), _vm._v(" "), _c('p', {
    staticClass: "C298"
  }, [_vm._v("Fairy tales represent hundreds of years of stories based on thousands of years of stories told by hundreds, thousands, perhaps even millions of tellers. The mind reels at their influence, omnipresence, phosphorescence: like a star or a planet, they shine, ubiquitous and necessary. Like the sea, threatened now by our changing climate, fairy tales, too, are in danger today—often forgotten by grown-up people afraid of wonder—and therefore endangered.")]), _vm._v(" "), _c('p', {
    staticClass: "C298"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("For me what also contains this issue and holds it within the salt palace of tiny sea horses is how the narratives and poems, taken together in here, can be seen to contribute not only to the very important living body of contemporary fairy tales—so nascent and now—but also to the conversation about what constitutes “a fairy tale,” that monumental type of art we so know and love. As such, I hope that FAIRY TALE REVIEW helps preserve and protect fairy tales for future generations of readers who wish to immerse in their bounty.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "C252"
  }, [_vm._v("Kate Bernheimer"), _c('br'), _vm._v("\nTucson, AZ")])]), _c('p', {
    staticClass: "C561"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('em')]), _c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Editor_s_Note#id_2",
      "id": "id_3"
    }
  }, [_vm._v("1")]), _vm._v(". Colebrook, Claire")]), _vm._v(", Gilles Deleuze, "), _c('em', [_vm._v("Routledge: 2002 (26)")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76186919","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Editor_s_Note.vue
// module id = 72
// module chunks = 0